import * as React from 'react';

import Paragraph from 'global_elements/Text/Paragraph';
import MultiSelect from 'global_elements/Inputs/Dropdown/MultiSelect';

import { LabeledMultiSelectProps } from 'types/inputProps';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import './styles.scss';
import FlexContainer from 'global_elements/Layouts/FlexContainer';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';

const LabeledMultiSelect = (props: LabeledMultiSelectProps): React.JSX.Element => (
  <label className="labeled-multi-select">
    <FlexContainer display={DisplayVariant.FLEX_ROW} align={AlignVariant.START} justify={JustifyVariant.START}>
      <Paragraph
        text={props.label}
        fontColor={props.labelFontColor ? props.labelFontColor : FontColors.DARK_GRAY}
        fontSize={props.labelFontSize ? props.labelFontSize : FontSizes.REGULAR}
        bold
        extraClasses="labeled-multi-select__header"
      />
      {props.showRequiredAsterisk && (
        <Paragraph text="*" fontColor={FontColors.HIGH_PRIORITY} fontSize={props.labelFontSize ? props.labelFontSize : FontSizes.REGULAR} bold extraClasses="labeled-multi-select__header" />
      )}
    </FlexContainer>

    <MultiSelect
      styles={props.styles}
      placeholder={props.placeholder}
      defaultValue={props.defaultValue}
      value={props.value}
      options={props.options}
      onSelection={props.onSelection}
      closeMenuOnSelect={props.closeMenuOnSelect ?? true}
      allowSelectAll={props.allowSelectAll ?? false}
      allOption={props.allOption ?? undefined}
      hideNoOptionsMessage={props.hideNoOptionsMessage}
    />
  </label>
);

export default LabeledMultiSelect;
